import * as lang from 'shared/lib/modules/sharedLang.js';
lang.add({
    /* eslint-disable camelcase */
    // sorting
    avreise: 'Avreisedato (tidlig - sen)',
    pris_lms: 'Pris per person',
    pris_pp: 'Prisnivå',
    best: 'Beste treff',
    rating: 'Hotellstandard',

    // filters
    unspecified_lodging: 'Uspesifisert bosted',
    specified_lodging: 'Spesifisert bosted',
    flight_only: 'Kun fly - tur/retur',
    one_way_flight: 'Kun fly - en vei',
    missing_time: 'tidspunkt ikke fastsatt',

    // save search
    save_search_failure: 'Det skjedde en feil og søket ble ikke lagret. Prøv igjen!',
    save_search_success: 'Søket er lagret!',
    /* eslint-enable camelcase */
});
